import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTODiffusionModelsTableGeneric } from '../table_base/dto_diffusion_model_table_base';
import { DTODiffusionModelsTablePageUD } from './dto_diffusion_models_table_page_ud';

export class DTODiffusionModelsTableUD extends DTODiffusionModelsTableGeneric<DTODiffusionModelsTablePageUD> {
  /*
   * STATIC FIELDS
   */

  static readonly _class_name_static: string = ENUM__dto_class_name.DIFFUSION_MODELS_TABLE_UD;

  /*
   * FIELDS
   */
  override create_page_stub() {
    return DTODiffusionModelsTablePageUD.CREATE_STUB();
  }
}
